import type { GenericSchema } from 'valibot'
import { array, object } from 'valibot'
import { baseBodySchema } from './body'
import { headersSchema } from './headers'

export function createSolrResponseSchema<T extends GenericSchema>(docsSchema: T) {
  return object({
    responseHeader: headersSchema,
    response: object({
      ...baseBodySchema.entries,
      docs: array(docsSchema),
    }),
  })
}
